export const MaskEnum = {
    NATIONAL_IDENTIFICATION_NUMBER: '99.99.99-999.99',
    COMPANY_NUMBER: '9999.999.999',
};
